/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseEditorialWrapperFragment} from '@amblique/contentful/app/contentful/fragments/editorial-wrapper/base-editorial-wrapper.fragment';
import {ContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/container.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {ShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/shop-the-look.fragment';

export const FullEditorialWrapperFragment = gql`
  ${BaseEditorialWrapperFragment}
  ${ContainerFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${ShopTheLookFragment}

  fragment FullEditorialWrapperFragment on EditorialWrapper {
    ...BaseEditorialWrapperFragment

    contentCollection {
      items {
        __typename
        ... on Container {
          ...ContainerFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on ShopTheLook {
          ...ShopTheLookFragment
        }
      }
    }
    contentCursorCollection {
      items {
        __typename
        ... on Container {
          ...ContainerFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on ShopTheLook {
          ...ShopTheLookFragment
        }
      }
    }
  }
`;
